// class for working with URLs
// Url.create().qs.city_id -> get "city_id" querystring
// Url.create('/nyc/cities?q=456').set('foo', 123).set('q').render() -> "/nyc/cities?foo=123"
// Url.create().render({url:true}) -> render full url with proto "https://..."

// url = $.url('/projects/tag:dux?foo=bar123').qs('foo1', 'bar22').qs('foo', null).pqs('xx', 'yyy').qs('tag', '1234').get()
// url.get () -> { tag: "1234", xx: "yyy", foo1: "bar22" }
// url.render() -> "/projects/tag:dux/xx:yyy?foo1=bar22&tag=1234"

let Url = class Url {
  static create(url) {
    return new window.Url(url);
  }

  constructor(url) {
    var el, i, key, len, parts, query, ref, v;
    url || (url = location.href);
    parts = url.split('?', 2);
    parts[1] || (parts[1] = '');
    query = parts.pop();
    parts = parts[0].split('/');
    if (url.includes('://')) {
      this.host = parts.splice(0, 3).join('/');
      parts.unshift('');
    } else {
      this.host = '';
    }
    this.pathQs = {};
    parts = parts.filter((el) => {
      var k, v;
      if (el && el.includes(':')) {
        [k, v] = el.split(':', 2);
        if (v) {
          this.pathQs[k] = decodeURIComponent(v);
        }
        return false;
      } else {
        return true;
      }
    });
    this.root = parts[1];
    this.path = parts.join('/');
    this.query = {};
    ref = query.split('&');
    for (i = 0, len = ref.length; i < len; i++) {
      el = ref[i];
      [key, v] = el.split('=', 2);
      if (v) {
        this.query[key] = decodeURIComponent(v);
      }
    }
  }

  setPath(v) {
    this.path = v;
    return this
  }

  setHost(v) {
    this.host = v;
    return this
  }

  // qs /?bar=baz
  qs(key, v) {
    if (typeof key === 'object') {
      Object.entries(key).forEach((el) => {
        return this.query[el[0]] = el[1];
      });
      return this;
    } else if (!key) {
      return this.query;
    } else if (v === void 0) {
      return this.query[key];
    } else {
      if (v) {
        this.query[key] = v;
      } else {
        delete this.query[key];
      }
      return this;
    }
  }

  // path qs /bar:baz
  pqs(key, v) {
    if (v === void 0) {
      this.pathQs[key];
    } else {
      if (v) {
        this.pathQs[key] = v;
        return this;
      } else {
        delete this.pathQs[key];
      }
    }
    return this;
  }

  // get querystring of path querystring
  get(key) {
    if (key) {
      return this.query[key] || this.pathQs[key];
    } else {
      return Object.assign(this.pathQs, this.query);
    }
  }

  render(opts = {}) {
    var base, k, ref, v;
    if (opts.full) {
      base = this.host || location.origin;
    } else {
      base = '';
    }
    base += this.path;
    ref = this.pathQs;
    for (k in ref) {
      v = ref[k];
      base += `/${k}:${encodeURIComponent(v)}`;
    }
    if (Object.keys(this.query)[0]) {
      base += '?';
      base += Object.entries(this.query).map(function(el) {
        return `${el[0]}=${encodeURIComponent(el[1])}`;
      }).join('&');
    }
    return base;
  }

  turbo(opts) {
    const path = this.render(opts)
    window.Turbo.visit(path)
  }
};

if (window.$) {
  window.$.url = function(url) {
    return new Url(url);
  };
} else {
  window.Url = Url;
}
